import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import DeleteIcon from 'material-ui/svg-icons/action/delete';


import Moment from 'react-moment';
import 'moment-timezone';
import 'moment/locale/es';


const deleteStyle = {
    padding: '0px',
    width: 36,
    height: 36,
};

let mainStyle = {
    opacity: '1',
};

let loadingStyle = {
    opacity: '0.25',
};

class Item extends Component {

    state = {
        loading: false
    };

    static propTypes = {
        id: PropTypes.number,
        item: PropTypes.object,
        newDay: PropTypes.bool,
        onDelete: PropTypes.func
    }

    onDeleteHandler = (e) => {
        if (typeof this.props.onDelete === 'function') {
            this.setState({ loading: true })
            this.props.onDelete(this);
        }
    }


    render() {

        const calendarStrings = {
            lastDay : '[Ayer]',
            sameDay : '[Hoy]',
            lastWeek : 'dddd D',
            sameElse : 'dddd D [de] MMMM'
        };

        const { newDay } = this.props;
        const { loading } = this.state;

        return (
            <div>
                {newDay &&
                    <div className="item heading">
                        <Moment calendar={calendarStrings}>{this.props.item.date}</Moment>
                    </div>
                }

                {this.props.item.task &&
                <div className="item" style={loading?loadingStyle:mainStyle}>
                    <div className="description">{this.props.item.description}</div>
                    <div className="task"><strong>{this.props.item.client.name}</strong>{'.  ' + this.props.item.project.name + ' (' + this.props.item.task.midname + ')'}</div>
                    <div className="hours">{this.props.item.hours}<small>&nbsp;hs</small></div>
                    <div className="actions">
                        <IconButton tooltip="Eliminar" style={deleteStyle} tooltipPosition="top-left" onClick={this.onDeleteHandler}>
                            <DeleteIcon />
                        </IconButton>
                    </div>
                </div>
                }

            </div>
        );

    };

}

export default Item;


// WEBPACK FOOTER //
// ./src/modules/user/Item.js